import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import globalMessagesReducer from '../features/global-messages/global-messages-slice';
import connectionStatusReducer from '../features/connection-status/connection-status-slice';

export const store = configureStore({
    reducer: {
        counter: counterReducer,
        globalMessages: globalMessagesReducer,
        connectionStatus: connectionStatusReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
